import { Grid } from "@material-ui/core"
import { TextButton } from "@tfo/common"
import { observer } from 'mobx-react'
import personnummer from 'personnummer.js'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useStore } from '../../../hooks/useStore'
import bank from '../../../media/images/BankID_logo.svg'
import { LoginMethod as LoginMethodEnum } from '../../../models/enums/LoginMethod'
import $http from '../../../utils/$http'
import ActivateBankId from "../activate-bankid/ActivateBankId"
import ChangePassword from "../change-password/ChangePassword"

type NationalIdResponse = {
	nationalId: string
}

export const LoginMethod = observer(() => {
	const intl = useIntl()
	const [nationalId, setNationalId] = React.useState<string>('')
	const [displayMode, setDisplayMode] = React.useState<LoginMethodEnum>(LoginMethodEnum.Password)

	const { userStore } = useStore()

	const bankIdIcon = () => <img className="bankId-icon" src={bank} alt="BankId Logo"></img>

	React.useEffect(() => {
		setDisplayMode(userStore.user.loginType)
		if (userStore.user.loginType === LoginMethodEnum.BankId) {
			getNationalId()
		}
	}, [userStore.user.loginType])

	const parseNationalId = (nationalId: string) => {
		const parsedNationalId = personnummer.parse(nationalId.replace('SE-', ''), { normaliseFormat: "YYYYMMDD-NNNN" }).normalised
		setNationalId(parsedNationalId)
	}

	const getNationalId = async () => {
		const response = await $http.get<NationalIdResponse>('/user/customer/nationalId')
		if (response.nationalId === null || response.nationalId === undefined) {
			return
		}
		parseNationalId(response.nationalId)
	}

	const changeLoginMethod = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, newValue: LoginMethodEnum) => {
		setDisplayMode(newValue)
	}

	return (
		<Grid className='login-method-container' container spacing={3} justifyContent='flex-end'>
			<Grid container item xs={6} direction="column">
				{/* If user has SSO login method, show restriction message */}
				{userStore.user.loginType === LoginMethodEnum.SSO ? (
					<div className="sso-restriction-message">
						<h3>{intl.formatMessage({ id: 'common.loginMethod.current' })}: SSO</h3>
						<p>{intl.formatMessage({ id: 'common.loginMethod.sso.companyRestricted' })}</p>
					</div>
				) : (
					/* Normal login method switching for Password/BankId users */
					displayMode === LoginMethodEnum.BankId ? (
						<>
							<div className='login-method-box'>
								<TextButton
									className='myaccount-textButton'
									secondary
									onClick={(event) => changeLoginMethod(event, LoginMethodEnum.Password)}
									iconReversed>
									{intl.formatMessage({ id: 'common.loginMethod.change' })} {intl.formatMessage({ id: 'common.password' })}
								</TextButton>
							</div>
							<ActivateBankId nationalId={nationalId} parseNationalId={parseNationalId} />
						</>
					) : (
						<>
							<div className='login-method-box'>
								<TextButton
									className='myaccount-textButton'
									secondary
									icon={bankIdIcon()}
									onClick={(event) => changeLoginMethod(event, LoginMethodEnum.BankId)}
									iconReversed>
									{intl.formatMessage({ id: 'common.loginMethod.change' })} {intl.formatMessage({ id: 'common.bankId' })}
								</TextButton>
							</div>
							<ChangePassword loginMethod={userStore.user.loginType} />
						</>
					)
				)}
			</Grid>
		</Grid>
	)
})
